import { useEffect, useState } from "react";
import { Phone, MessageCircle, ClipboardCheck } from "lucide-react";
import { site, offer, whatsappPrefill } from "@/config/site";

export const MobileActionBar = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.5);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div
            data-testid="mobile-action-bar"
            className={`fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-rz-steel bg-rz-black/90 backdrop-blur-md transition-transform duration-500 md:hidden ${
                show ? "translate-y-0" : "translate-y-full"
            }`}
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
            <a
                data-testid="mobile-bar-call-button"
                href={`tel:${site.phone}`}
                className="flex h-14 items-center justify-center gap-2 font-display text-[11px] font-semibold uppercase tracking-[0.18em] text-rz-white"
            >
                <Phone size={15} /> Call
            </a>
            <a
                data-testid="mobile-bar-whatsapp-button"
                href={site.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-14 items-center justify-center gap-2 border-l border-rz-steel font-display text-[11px] font-semibold uppercase tracking-[0.18em] text-rz-white"
            >
                <MessageCircle size={15} /> WhatsApp
            </a>
            <a
                data-testid="mobile-bar-enquire-button"
                href={whatsappPrefill(offer.message)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-14 items-center justify-center gap-2 bg-rz-red font-display text-[11px] font-semibold uppercase tracking-[0.14em] text-white"
            >
                <ClipboardCheck size={15} /> Free Inspection
            </a>
        </div>
    );
};
